import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import "../css/EnquiryList.css"
import { ShimmerTable } from "react-shimmer-effects";

import ic_app_logo from "../img/autoland_logo_original.png";

function AdminDashboard() {

    const navigate = useNavigate()

    const [isSending, setIsSending] = useState(false);
    const [listOfEnquiry, setListOfEnquiry] = useState([]);
    const [stateCompanyCode, setCompanyCode] = useState("");

    const clickedOnAccept = (companyname) => {

        const apiUrl = `${process.env.REACT_APP_BASE_URL}/partnerrequest/STATUSUPDATE/${companyname?.trim()}/ACCEPTED`;

        axios.get(apiUrl).then((res) => {

            console.log("res is ", res)
        }).catch((err) => {
            console.log("err is ", err)
        })

    }

    const clickedOnReject = (companyname) => {

        const apiUrl = `${process.env.REACT_APP_BASE_URL}/partnerrequest/STATUSUPDATE/${companyname?.trim()}/REJECTED`;

        axios.get(apiUrl).then((res) => {

            console.log("res is ", res)
        }).catch((err) => {
            console.log("err is ", err)
        })

    }

    const getListOfEnquiries = () => {

        setIsSending(true);

        let current_company_local = localStorage.getItem("current_company");
        let currentCompany;
        if (current_company_local) {
            currentCompany = JSON.parse(localStorage.getItem("current_company"));

            console.log("Home page company value is  ", currentCompany);

            setCompanyCode(currentCompany.company_code);
        }

        const apiUrl = `https://cubixweberp.com:223/api/partnerrequest/FULL_LIST`;

        console.log("api url >>", apiUrl);

        axios
            .get(apiUrl)
            .then((res) => {

                setIsSending(false);

                console.log("Enquiry Table response ", res.data);
                setListOfEnquiry(res.data);
            })
            .catch((e) => {
                console.log("the error in Homepage api call " + e);
                setIsSending(false);
            });
    };

    const getBackGroundColor = (statusReceived) => {

        switch (statusReceived) {
            case "Waiting For Accept": return "waiting_for_accept"
            case "Order Confirmed": return "order_confirmed"
            case "Quotation Generated": return "quotation_generated"
            default: return "waiting_for_accept"
        }


    }

    useEffect(() => {
        console.log("HomePage Machine component >>>>>>> MOunted ");

        getListOfEnquiries();

        return function cleanup() {
            console.log("HomePage Machine component <<<<<<< unmounted ");
        };
    }, []);

    return (
        <div>
            <div className="Login-logo-container" style={{display:"flex", alignItems:"center" }}>

                <img className="Header-app-logo"
                    style={{ width: "200px", margin: "20px" }}
                    src={ic_app_logo} />
                <h6 style={{backgroundColor:"#f7f7f7"}}>Admin Dashboard</h6>

            </div>

            <div className="container mt-4">





                <h6>Customer Registration list</h6>

                <div className="Enquiry_list_table_container" >
                    {isSending ? (

                        <ShimmerTable row={10} />

                    ) : (
                        <table className="HomePage-table">
                            <thead>
                                <tr>
                                    <th>Customer name</th>
                                    <th>Company name</th>
                                    <th>Status</th>
                                    <th>phone number</th>
                                    <th>Email id </th>
                                    <th>Type of business</th>
                                    <th>Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listOfEnquiry.map((item, index) => {
                                    return (
                                        <tr
                                        >

                                            <td>{item.cust_Name
                                            }</td>
                                            <td>
                                                {item.compnyName}


                                            </td>
                                            <td>
                                                {item.status == null ? "PENDING" : item.status}
                                            </td>
                                            <td>



                                                {item.phone}




                                            </td>
                                            <td>

                                                {item.emailid}

                                            </td>
                                            <td>

                                                {item.typebusiness}

                                            </td>
                                            <td>

                                                --/--/----
                                            </td>
                                            <td>
                                                {
                                                    item.status == null &&

                                                    <div>
                                                        <button className="btn btn-primary btn-sm " onClick={() => { clickedOnAccept(item.compnyName) }}>ACCEPT</button>
                                                        <button className="btn btn-sm btn-dark ms-2" onClick={() => { clickedOnReject(item.compnyName) }}>REJECT</button>
                                                    </div>
                                                }

                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>

            </div>
        </div>
    );
}
export default AdminDashboard;
